const BentoGrid = ({ children, className = "" }) => {
  return (
    <div className={`grid gap-6 md:grid-cols-3 lg:grid-cols-4 ${className}`}>
      {children}
    </div>
  );
};

const BentoGridItem = ({ 
  title, 
  description, 
  icon, 
  className = "",
  colSpan = "md:col-span-1",
  rowSpan = "md:row-span-1" 
}) => {
  return (
    <div
      className={`
        group relative overflow-hidden rounded-xl border bg-white p-6 shadow-sm 
        hover:shadow-lg transition-all duration-300 hover:-translate-y-1
        ${colSpan} ${rowSpan} ${className}
      `}
    >
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-deep-green/5 to-forest-green/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      
      {/* Content */}
      <div className="relative z-10">
        {icon && (
          <div className="h-12 w-12 flex items-center justify-center rounded-lg bg-deep-green/10 text-deep-green text-2xl mb-4 group-hover:bg-deep-green/20 transition-colors duration-300">
            {icon}
          </div>
        )}
        
        <h3 className="text-lg font-semibold text-charcoal mb-2 group-hover:text-deep-green transition-colors duration-300">
          {title}
        </h3>
        
        <p className="text-gray-600 leading-relaxed">
          {description}
        </p>
      </div>
      
      {/* Subtle border glow on hover */}
      <div className="absolute inset-0 rounded-xl border border-deep-green/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
    </div>
  );
};

export { BentoGrid, BentoGridItem };
